<template>
  <div>
    <div class="form">
      <Form v-if="!done"
            id="form"
            form_id="5f3f8b07b080ef001752ae87"
            :submission_id="submission_id"
            :server="server"
            v-on:results="getResult"
          />
          <div v-else>
            <iframe :src="this.gif" width="480" height="270" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/republicrecords-drake-KFhTeqMhIHheY587Bx">via GIPHY</a></p>
          </div>
      </div>
  </div>
</template>
<script>
var consts = require('../config');
import axios from "axios";
import giphyRandom from "giphy-random";

export default {
  name: "Jouez",
  data: function() {
    return {
      step: 0,
      done: false,
      submission_id: this.$route.params.submissionId,
      game_id: this.$route.params.id,
      server : consts.SERVER_URL,
    };
  },
  methods: {
    getResult(result) {
      this.done = true;
      setTimeout(()=>{
        this.$router.replace("/whaoo");
      }, 3000);
    },
  },
  async mounted () {
    //this.gif = 
    const { data } = await giphyRandom("nkM1CPYkMVvNpFytxxX3qmGuEFJcvk93");
    this.gif = data.embed_url;
  },
  created: function() {

  }
}
</script>
<style>
button {
  margin-top:20px;
}
</style>